import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { MILESTONES } from 'lib/constants';
import { PATH_ROUTES } from 'routes/path';
import useAuthStore from 'store/auth';

export default function useDashboard() {
  const { pathname } = useLocation();
  const currentMilestone = useAuthStore((store) => store.currentMilestone);

  const isDashboard = useMemo(
    () =>
      pathname === PATH_ROUTES.DASHBOARD &&
      ![MILESTONES.TNC, MILESTONES.USER_DETAIL].includes(
        currentMilestone as MILESTONES
      ),
    [pathname, currentMilestone]
  );

  return { isDashboard };
}
